Config = {

	isMobile: ->
		true is $('#site-header .cta_menu_mobile').is(':visible')

	isTouchDevice: ->
		true is ("ontouchstart" of window or window.DocumentTouch and document instanceof DocumentTouch)
}